'use es6';

import locationOrigin from './locationOrigin';
import apiEnvironments from '../constants/apiEnvironments';
import createChainablePropType from 'UIComponents/utils/propTypes/createChainablePropType';
const links = {
  shortlink(path = '') {
    return `${locationOrigin}/l/${path}`;
  },
  productSetup(portalId, product = '') {
    if (!portalId) {
      return `${locationOrigin}/configuration/`;
    }
    return `${locationOrigin}/configuration/${portalId}/${product}`;
  },
  crmStartPage(portalId) {
    return `${locationOrigin}/contacts/${portalId}/start`;
  },
  signuplink() {
    return `${locationOrigin}/signup/`;
  },
  // ---------------------------------------------------------------------------
  // utilities

  login(next) {
    let query = '';
    if (next) {
      query = `?loginRedirectUrl=${encodeURIComponent(next)}`;
    }
    return `${apiEnvironments.HUBSPOT_LOGIN}${query}`;
  },
  loginWithRedirect(redirect, portalId = '') {
    const path = encodeURIComponent(redirect);
    const redirectTo = `?loginRedirectUrl=${path}`;
    let enforcePortal = '';
    if (portalId) {
      enforcePortal = `&loginPortalId=${portalId}`;
    }
    return `${links.login()}${redirectTo}${enforcePortal}`;
  },
  portalUpgrades(portalId) {
    return `${locationOrigin}/upgrades/${portalId}`;
  },
  // ---------------------------------------------------------------------------
  // features
  homeService(portalId, appDomain) {
    return `${appDomain || locationOrigin}/home?portalId=${portalId}`;
  },
  salesDashboard(portalId) {
    return `${locationOrigin}/reports-dashboard/${portalId}/sales`;
  },
  // generic default
  marketingFree(portalId) {
    return `${locationOrigin}/marketing/${portalId}/`;
  },
  marketingFreeContacts(portalId) {
    return `${locationOrigin}/marketing/${portalId}/contacts`;
  },
  marketingFreeLeadFlows(portalId) {
    return `${locationOrigin}/lead-flows/${portalId}/`;
  },
  marketingFreeForms(portalId) {
    return `${locationOrigin}/forms/${portalId}/`;
  },
  developers(portalId) {
    return `${locationOrigin}/developers/${portalId}/`;
  },
  // generic default
  crm(portalId) {
    return `${locationOrigin}/contacts/${portalId}`;
  },
  crmContacts(portalId) {
    return `${locationOrigin}/contacts/${portalId}/contacts`;
  },
  crmCompanies(portalId) {
    return `${locationOrigin}/contacts/${portalId}/companies`;
  },
  crmDeals(portalId) {
    return `${locationOrigin}/contacts/${portalId}/deals`;
  },
  crmTasks(portalId) {
    return `${locationOrigin}/contacts/${portalId}/tasks`;
  },
  salesNotifications(portalId) {
    return `${locationOrigin}/sales-stream/${portalId}/all`;
  },
  salesTemplates(portalId) {
    return `${locationOrigin}/templates/${portalId}/`;
  },
  salesSequences(portalId) {
    return `${locationOrigin}/sequences/${portalId}`;
  },
  salesDocuments(portalId) {
    return `${locationOrigin}/presentations/${portalId}`;
  },
  salesProspects(portalId) {
    return `${locationOrigin}/contacts/${portalId}/visits`;
  },
  salesMeetings(portalId) {
    return `${locationOrigin}/meetings/${portalId}`;
  },
  salesPro(portalId) {
    return `${locationOrigin}/browse/${portalId}/compare/sales`;
  },
  academy(portalId) {
    return `${locationOrigin}/learning-center/${portalId}`;
  },
  oauth(portalId) {
    return `${locationOrigin}/oauth/${portalId}/authorize`;
  },
  oauthBeta(portalId) {
    return `${locationOrigin}/oauth-beta/${portalId}/authorize`;
  },
  guideCreator(portalId) {
    return `${locationOrigin}/guide-creator/${portalId}/auth/redirect?checkGuide=false`;
  },
  campaignAssistant(portalId) {
    return `${locationOrigin}/campaign-assistant/${portalId}/dashboard`;
  },
  clipCreator(portalId) {
    return `${locationOrigin}/clip-creator/${portalId}`;
  },
  codeFunnelAnatomy() {
    return 'https://offers.hubspot.com/thank-you/anatomy-of-a-five-star-email-b';
  },
  codeFunnelSeo() {
    return 'https://offers.hubspot.com/thank-you/seo-myths-b';
  },
  codeFunnelInfographics() {
    return 'https://offers.hubspot.com/thank-you/generate-leads-with-infographics-b';
  },
  codeFunnelTemplates() {
    return 'https://offers.hubspot.com/thank-you/call-to-action-templates-b';
  }
};
function redirectLinkChecker(props, propName, componentName) {
  if (!Object.values(links).includes(props[propName])) {
    return new Error(`${propName} specified in ${componentName} is not valid. Use links defined in utils/links.js`);
  }
  return null;
}
export const redirectLink = createChainablePropType(redirectLinkChecker, 'redirectLink');
export default links;